<template>
  <div class="BonusVideoGallery float-left col-md-3 col-lg-3 hover-border:hover">
    <div class="width-100Perc border-1px margin-top-6Perc margin-bottom-6Perc hover-border">
      <div class="text-align margin-right-2Perc border-red alignItemCenter">
        <input type="checkbox" v-model="selectedCheckBoxValue" class="marginLeft3px">
        <img :src="iconEdit" alt="iconEdit" class="img-responsive height-12Px width-13 img-opacity image-edit-zindex-1 cursor-pointer display-inline marginLeft3px" @click="selectedOperation($event,'edit')">
        <img :src="iconDelete" alt="iconDelete" class="img-responsive height-15Px width-13 img-opacity image-delete-zindex-1 cursor-pointer display-inline marginLeft3px" @click="askUserConfirmation($event,'delete')">
        <!-- <span>Checked names: {{ removeVideoChkBoxArray }}</span> -->
      </div>
      <div class="padding-0px">
        <div v-if="audioUrl !== null && audioUrl !== 'null' && audioUrl !== '' && audioUrl !== undefined">
          <audio controls controlsList="nodownload" class="audio-width margin-bottom-2Perc margin-top-3Perc">
            <source :src="audioUrl" type="audio/mp3">
            <source src="" type="audio/mp3">
          </audio>
        </div>
        <div v-else class="no-video-width-height margin-bottom-2Perc margin-top-3Perc displayFlex">
          <div class="marginZeroAuto">
            No audio available
          </div>
        </div>
        <video width="" controls controlsList="nodownload" class="width-100Perc height-100Perc">
         <source :src="videoUrl" type="video/mp4">
        </video>
      </div>
      <div class="tooltip1">{{getTruncatedTitle(getBonusVideoObj.Title)}}
        <span class="tooltiptext"><b>{{getBonusVideoObj.Title}}</b></span>
      </div>
      <!-- <img :src="iconDelete" alt="iconDelete" class="img-responsive img-align height-15Px width-13 img-opacity image-delete-zindex-1 cursor-pointer" >   -->
    </div>
    <!-- <loader></loader> -->
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="getBonusVideoObj" v-bind:prefixString="prefixDeleteElementString" v-bind:postfixString="postDeleteElementString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedElement"></confirmation-alert> -->
    <!-- <confirmation-alert v-if="showConfirmationBox"  v-bind:dataObj="getBonusVideoObj" v-bind:prefixString="prefixDeleteElementString" v-bind:postfixString="postDeleteElementString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performPostConfirmation"></confirmation-alert> -->
    <confirmation-alert v-if="showConfirmationBox"  v-bind:dataObj="getBonusVideoObj" v-bind:prefixString="prefixDeleteElementString" v-bind:postfixString="postDeleteElementString" @showConfirmationBox="updateShowConfirmationAlertFlag"></confirmation-alert>
  </div>
</template>
<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { constants } from '@/utils/constants'
import copyicon from '../../assets/images/copyicon.svg'
import iconEdit from '../../assets/images/edit.svg'
import iconDelete from '../../assets/images/delete.svg'
import { elementService } from '@/server-util/element-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['bonusVideoObj'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      iconDelete: iconDelete,
      copyicon: copyicon,
      iconEdit: iconEdit,
      showConfirmationBox: false,
      showCopyConfirmationBox: false,
      prefixDeleteElementString: '',
      postDeleteElementString: '',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      videoUrl: '',
      audioUrl: '',
      copyDeleteVideoFlag: '',
      isSelected: false
    }
  },
  computed: {
    getBonusVideoObj: {
      get: function () {
        return this.bonusVideoObj
      }
    },
    selectedCheckBoxValue: {
      get: function () {
        return this.isSelected
      },
      set: function (newValue) {
        this.isSelected = newValue
        var objToPass = {
          selectedBonusObj: this.getBonusVideoObj,
          isSelected: newValue
        }
        this.$emit('pushOrPopBonusObj', objToPass)
      }
    }
  },
  components: {
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox
  },
  methods: {
    setDefaultValues: function () {
      // console.log('getBonusVideoObj >>> ' + JSON.stringify(this.getBonusVideoObj))
      this.videoUrl = this.getBonusVideoObj.VideoUrl
      this.audioUrl = this.getBonusVideoObj.AudioUrl
    },
    selectedOperation: function (event, operationToPerform) {
      var obj = {
        selectedOperation: operationToPerform,
        selectedElemObj: this.getBonusVideoObj,
        selectedBonusObj: null
      }
      // AK: Emit to ViewBonusLesson file for edit/delete operation
      this.$emit('selectedOperation', obj)
    },
    getTruncatedTitle: function (stringToTruncate) {
      if (stringToTruncate.length > 22) {
        return dmAdminUtils.truncateString(stringToTruncate, 22) + '...'
      }
      return stringToTruncate
    },
    // askUserConfirmation: function () {
    //   AK: show confirmation dialog before delete
    //   this.showConfirmationBox = true
    // },
    askUserConfirmation: function (event, operationToPerform) {
      if (operationToPerform === 'copy') {
        console.log('copy operation')
        this.showConfirmationBox = true
        this.prefixDeleteElementString = 'Are you sure you want to copy '
        this.postDeleteElementString = '?'
        this.copyDeleteVideoFlag = operationToPerform
      } else {
        console.log('delete operation')
        this.showConfirmationBox = true
        this.prefixDeleteElementString = 'Are you sure you want to delete '
        this.postDeleteElementString = '?'
        this.copyDeleteVideoFlag = operationToPerform
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    performPostConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        if (this.prefixDeleteElementString === 'Are you sure you want to copy ') {
          this.copySelectedElement(value)
        } else {
          this.deleteSelectedElement(value)
        }
      }
    },
    deleteSelectedElement (value) {
      console.log(value)
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.bonusVideoObj.ElementId !== undefined ||
          this.bonusVideoObj.length > 0
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          // AK: Hide Delete Confirmation Box
          _this.showConfirmationBox = false
          elementService
            .deleteElement(storeObj.state.access_token, _this.bonusVideoObj.ElementId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.$store.state.isLoading = false
                // AK: Refresh Element List
                _this.$emit('refreshList', true)
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected Lesson Object is NULL hence declined DELETE OPERATION'
          )
        }
      }
    },
    copySelectedElement (value) {
      console.log('copySelectedElement')
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.bonusVideoObj.ElementId !== undefined ||
          this.bonusVideoObj.length > 0
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          // AK: Hide Delete Confirmation Box
          _this.showConfirmationBox = false
          elementService
            .deleteElement(storeObj.state.access_token, _this.bonusVideoObj.ElementId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.$store.state.isLoading = false
                // AK: Refresh Element List
                _this.$emit('refreshList', true)
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected Lesson Object is NULL hence declined DELETE OPERATION'
          )
        }
      }
    }
  },
  name: 'BonusVideoGallery'
}
</script>

<style scoped>
.opacity-0Point5 {
  background: red;
  opacity: 0.5;
}
.BonusVideoGallery {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.margin-left-1Point5Perc{
  margin-left: 1.5%;
}
.float-left {
  float: left !important;
  /* clear:right !important; */
}
.text-wrap {
    /* width: 11em;  */
    /* border: 1px solid #000000; */
    word-wrap: break-word !important;
    /* text-align: justify; */
}
.height-190px{
 height: 190px;
}
.width-100Perc{
  width: 100%;
}
.border-1px{
    border: 1px solid #ccc;
}
.margin-right-1Perc{
  margin-right: 1%;
}
.padding-0Perc{
  padding: 0% !important; 
}
.img-align{
    display: block;
    margin-left: auto;
    margin-right: auto;
    /* width: 40%; */
}
.height-15Px{
 height:15px; 
}
.width-13{
  width:13px;
}
.img-opacity{
  opacity:0.7;
}
.image-delete-zindex-1{
  /* position: absolute; */
  left: 278px;
  top: 130px;
  z-index: 1;
}
.cursor-pointer{
  cursor: pointer;
}
.width-100Perc{
  width:100%;
}
.height-100Perc{
  height:95% !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.margin-top-6Perc{
  margin-top: 6%;
}
.margin-bottom-6Perc{
  margin-bottom: 6%;
}
.text-overflow{
 text-overflow: ellipsis !important;
}
.padding-left-0Perc{
  padding-left: 0%; 
}
.padding-right-0Perc{
  padding-right: 0%; 
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
    cursor: pointer;
}
.tooltip1 .tooltiptext {
    visibility: hidden;
    width: 226px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top:100%;
    left:51%;
    margin-left: -114px;
}
.tooltip1:hover .tooltiptext {
    visibility: visible;
}
.height-20px{
  height:20px !important;
}
.bgcolor-black{
  background-color:black !important;
}
.padding-0px{
  padding:0% !important;
}
.image-edit-zindex-1{
    /* position: absolute; */
    left: 256px;
    top: 130px;
    z-index: 1;
}
.height-12Px{
 height:12px; 
}
.margin-left-5Perc{
  margin-left: 5%; 
}
.margin-right-0Point5Perc{
  margin-right:0.5%;
}
.margin-bottom-7Perc{
  margin-bottom: 7%;
}
.display-inline{
  display:inline;
}
.text-align{
  text-align: right;
}
.margin-right-2Perc{
  margin-right:2%;
}
.hover-border:hover{
  border: 1px solid #777;
}
.audio-width {
width:-webkit-fill-available;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.no-video-width-height {
  width: 100%;
  height:59px;
}
.padding-top-1em {
  padding-top:1em; 
}
.marginBottom0px {
  margin-bottom: 0px;
}
.positionUnset {
  position:inherit;
}
.marginLeft0px {
  margin-left: 0px;
}
.alignItemCenter {
  display: flex;
  align-items: center;
  float:right;
  margin-top: 4px;
}
.marginLeft3px {
  margin-left: 3px;
}
.displayFlex {
  display: inline-flex;
  align-items: center;
}
.textAlignCenter {
  text-align: center;
}
.marginZeroAuto {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/view_element/BonusVideoGallery.vue